// Angular
import { Injectable } from '@angular/core';
import { Router } from '@angular/router';

// rxjs
import { Subject } from 'rxjs';

// Models
import { DrawerOptions } from '@app/models/drawer-options';

@Injectable({
  providedIn: 'root',
})
export class DrawerService {
  private subject = new Subject<any>();
  public state = this.subject.asObservable();

  constructor(private router: Router) {}

  public open(options: DrawerOptions) {
    this.subject.next({ visible: true, options });
  }

  public dismiss() {
    this.subject.next({ visible: false });
  }
}
